var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1381 15.2511H16.2106V22.3126H13.2903V15.2511H11.9014V12.7694H13.2903V11.1635C13.2903 10.0151 13.8358 8.2168 16.2366 8.2168L18.3998 8.22585V10.6348H16.8303C16.5728 10.6348 16.2108 10.7634 16.2108 11.3112V12.7718H18.3933L18.1381 15.2511Z",
    fill: "#91A4CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.256690805ef76b9ccbff8ce8dbb8e5c5.svg";
export { ForwardRef as ReactComponent };